import React, { useEffect, useState } from 'react';

import { Divider, Spinner } from '@telus-uds/components-web';

import { TopBarMain } from './css';
import request from '../../../utils/request';

import Filter from './components/filter';
import Block from './components/block';

const Outlets = () => {
  const [apiData, setApiData] = useState();
  const [filterString, setFilterString] = useState('');

  const fetchData = async () => {
    try {
      const result = await request.get('/get-outletIds');

      if (result && result.status === 200) {
        setApiData(result.data.outletIds);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Divider space={3} variant={{ inverse: true }} />
      {!apiData && <Spinner show label="Loading data..." />}
      {apiData && (
        <>
          <TopBarMain>
            <Filter
              filterString={filterString}
              setFilterString={setFilterString}
            />
          </TopBarMain>
          <Divider space={3} variant={{ inverse: true }} />
          <Block
            data={apiData}
            filterString={filterString}
            fetchData={fetchData}
          />
        </>
      )}
    </>
  );
};

export default Outlets;
